<template>
    <div>
        <b-container fluid="sm">
            <b-row v-if="tipoestado == 'Nuevo'"
                   class="shadow-sm p-3 mb-5 bg-white rounded">
                <b-col class="md-layout-item md-layout md-gutter"
                       align="center" id="container" cols="12">
                    <v-stage :config="configKonva"
                             id="stageentrada"
                             ref="stageEntrada"
                             @mousedown="handleStageMouseDown"
                             @touchstart="handleStageMouseDown">
                        <v-layer id="layerFondo" ref="layerFondo">
                            <v-image :config="configVImagen" />
                        </v-layer>
                        <v-layer id="layerEntrada" ref="layerEntrada" :config="configVLayer">
                            <v-transformer ref="transformer" :config="cgfTransformer" />
                        </v-layer>
                    </v-stage>
                </b-col>
              
                    <b-col>
                        <b-toast id="edit-delete"
                                 title="Configuración elemento"
                                 variant="info"
                                 static
                                 no-auto-hide
                                 width="100px">
                            <template v-slot:toast-title>
                                <div class="d-flex flex-grow-1 align-items-baseline">
                                    <b-img blank
                                           blank-color="#ff5555"
                                           class="mr-2"
                                           width="12"
                                           height="12"></b-img>
                                    <strong class="mr-auto">Cambiar tamaño!</strong>
                                    <small class="text-muted mr-2">
                                        Solo debe ajustar la cuadricula sobre el elemento al tamaño que mas
                                        guste
                                    </small>
                                </div>
                            </template>
                            <b-button-toolbar>
                                <b-button-group size="sm" class="mr-1">
                                    <b-button variant="outline-info"
                                              id="eliminarElemento"
                                              @click="eliminarElemento()">
                                        <b-icon icon="trash"></b-icon>
                                        <small class="text-muted mr-2">Eliminar elemento seleccionado</small>
                                    </b-button>
                                    <b-button v-if="text"
                                              variant="outline-info"
                                              v-on:click="editarTransformar">
                                        <b-icon icon="pencil"></b-icon>
                                        <small class="text-muted mr-2">
                                            Editar fuente, color o tamaño del texto
                                        </small>
                                    </b-button>
                                </b-button-group>
                            </b-button-toolbar>
                        </b-toast>
                    </b-col>
              
            </b-row>            
            <b-row v-if="tipoestado == 'Nuevo'">
                <b-container class="bv-example-row">
                    <b-form-row>
                        <b-col>
                            <b-card>

                                <Colores @CambiaFondo="CambiaFondo($event)"
                                         :tipo="tipo"
                                         @setImagenDefault="setImagenDefault($event)" />

                            </b-card>
                            <b-card>

                                <Logo @AddLogo="AddLogo($event)" />

                            </b-card>
                            <b-card>


                                <Texto @AddTexto="AddTexto($event)"
                                       ref="Texto"
                                       @EditTexto="EditTexto($event)" />

                            </b-card>

                        </b-col>
                        <b-col>
                            <b-card>
                                <Pedido :tipo="tipo"
                                        :pulsera="selectPulsera"
                                        :colores.sync="setcolores"
                                        :precios.sync="setprecios"
                                        @AddPedido="AddPedido($event)"></Pedido>
                                <b-alert :show="dismissCountDown" dismissible fade :variant="variant">
                                    {{ mensaje }}
                                </b-alert>
                            </b-card>
                        </b-col>
                    </b-form-row>
                    <hr />


                </b-container>
            </b-row>
            <b-row v-if="tipoestado == 'Envio'" class="md-gutter">
                <b-col>
                    <Envio :getidPedido="getidPedido"
                           :setCantidad="setCantidad"
                           :GetPrecio="GetPrecio"></Envio>
                </b-col>
               
            </b-row>
        </b-container>
    </div>

</template>

<script>
    import Texto from './Texto.vue'
    import Colores from './Colores.vue'
    import Logo from './Logo.vue'
    import Pedido from './Pedido.vue'
    import Cantidad from './Cantidad.vue'
    import Envio from './Envio.vue'
    import axios from 'axios'

    export default {
        name: 'Contenedor',
        props: ['tipo', 'estado'],
        components: {
            Texto,
            Colores,
            Logo,
            Pedido,
            Cantidad,
            Envio,
        },

        computed: {
            getidPedido: {
                get: function () {
                    return this.idPedido
                },
                set: function (valor) {
                    this.idPedido = valor
                },
            },
            setCantidad: {
                get: function () {
                    return this.cantidad
                },
            },
            GetPrecio: {
                get: function () {
                    return this.precio
                },
            },
            setestado: {
                get: function () {
                    return this.estado
                },
            },
            trVisible: {
                get: function () {
                    return this.trActivo
                },
            },
            selectPulsera: {
                // getter
                get: function () {
                    let aux = ''
                    if (this.tipo == 'entradas') {
                        aux = this.tipo
                    }
                    if (this.tipo == 'pulseras') {
                        aux = this.color.split('/')[0]
                    }

                    return aux
                },
            },
            setcolores: {
                get: function () {
                    return this.colores
                },
                set: function (colores) {
                    this.colores = colores
                },
            },
            setprecios: {
                get: function () {
                    return this.precios
                },
                set: function (precios) {
                    this.precios = precios
                },
            },
        },
        data: function () {
            return {
                cgfTransformer: {
                    anchorStroke: 'dark',
                    anchorFill: 'gray',
                    borderStroke: 'black',
                    borderDash: [1, 3],
                },
                selectedShapeName: '',
                text: false,
                trActivo: false,
                idPedido: 0,
                cantidad: 0,
                precio: 0,
                tipoestado: this.estado,
                variant: 'warning',
                mensaje: '',
                dismissSecs: 20,
                dismissCountDown: 0,
                showDismissibleAlert: false,
                imagenDefault: '',
                elementos: [],
                logos: null,
                color: '',
                i: 0,
                configKonva: {
                    width: 800,
                    height: 300,
                    container: 'container',
                },
                configVImagenbuttonEditar: {
                    image: '',
                    x: 0,
                    y: 0,
                    width: 10,
                    height: 10,
                },
                configVImagenbuttonEliminar: {
                    image: '',
                    x: 0,
                    y: 0,
                    width: 10,
                    height: 10,
                },
                configVImagen: {
                    image: '',
                    x: 0,
                    y: 0,
                    width: 700,
                    height: 300,
                },
                configVLayer: {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                    offsetX: 0,
                    offsetY: 0,
                },
                configLogo: {
                    x: 0,
                    y: 0,
                    width: 106,
                    height: 118,
                },
                configTexto: {
                    x: 0,
                    y: 0,
                    scaleX: 1,
                    scaleY: 1,
                },
                colores: [],
                precios: [],
            }
        },
        created() { },
        methods: {
            EnviarPedido: function (datos, nombreFoto, stage2) {
                let formData = new FormData()
                formData.append('nombreFoto', nombreFoto)
                formData.append('tipo', this.tipo)
                formData.append('mail', datos.mail)
                formData.append('numero', datos.telefono)
                formData.append('nombre', datos.nombre)
                formData.append('ubicacion', datos.txtUbicacion)
                datos.total = 0
                let colores_cantidad = ''
                for (var key in datos.cantidades) {
                    if (datos.cantidades[key].cantidad > 0) {
                        colores_cantidad =
                            colores_cantidad +
                            ' Cantidad de ' +
                            this.tipo +
                            ' de Color ' +
                            datos.cantidades[key].color

                        if (this.selectPulsera != 'entradas') {
                            colores_cantidad =
                                colores_cantidad + ' en Material ' + this.selectPulsera
                        }

                        colores_cantidad =
                            colores_cantidad + ' : ' + datos.cantidades[key].cantidad + '\n'
                        datos.total += parseInt(datos.cantidades[key].cantidad)
                    }
                }
                formData.append('cantidad', datos.total)
                formData.append('cantidad_color', colores_cantidad)
                formData.append('precio', datos.precioTotal)
                formData.append(
                    'urlimagen',
                    process.env.VUE_APP_REGISTROS + this.tipo + '/' + nombreFoto
                )
                formData.append('uid', nombreFoto.split('_')[0])
                formData.append('nombreFoto', nombreFoto)
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }

                //Imagen a grabar
                const transformerNode = this.$refs.transformer.getNode()
                transformerNode.detach()
                transformerNode.getLayer().batchDraw()
                var dataURL = stage2.toDataURL({
                    mimeType: 'image/png',
                    pixelRatio: 3,
                })
                formData.append('imagen', dataURL)

                let resultado = axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_PHP,
                    data: formData,
                    config,
                })

                return resultado
            },
            FinalizaGrabacion(datos) {
                this.idPedido = datos.resultado.Id

                if (this.idPedido > 0) {
                    this.tipoestado = 'Envio'
                    this.cantidad = datos.total
                    this.precio = datos.precioTotal
                } else {
                    this.mensaje =
                        'Error en la generacion del pedido contacte al administrador.'
                    this.variant = 'warning'
                    this.showAlert()
                }
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            },
            AddPedido(datos) {
                var stage2 = this.$refs.layerEntrada.getStage()

                if (stage2.children.length > 1) {
                    const today = new Date()
                    const id = today.getTime()
                    let nombreFoto = id + '_' + this.tipo + '.png'

                    let resultado = this.EnviarPedido(datos, nombreFoto, stage2)

                    resultado
                        .then((result) => {
                            datos.resultado = result.data
                            this.FinalizaGrabacion(datos)
                        })
                        .catch(function (error) {
                            console.log(error)
                            datos.resultado = error
                        })
                } else {
                    this.mensaje =
                        'Las ' + this.tipo + ' a solicitar no pueden estar en blanco'
                    this.variant = 'warning'
                    this.showAlert()
                }
            },
            setMedidas: function () {
                var layer = this.$refs.layerEntrada.getStage()
                if (this.tipo == 'entradas') {
                    this.configKonva.width = 700
                    this.configKonva.height = 300

                    this.configVImagen.width = 700
                    this.configVImagen.height = 300
                    this.configVImagen.x = 10
                    this.configVImagen.y = 10

                    this.configVLayer.x = 10
                    this.configVLayer.y = 0
                    // this.configVLayer.width = 700;
                    layer.width(700)
                    //this.configVLayer.height = 200;
                    layer.height(200)
                    this.configVLayer.offsetX = 0
                    this.configVLayer.offsetY = 0

                    this.configLogo.x = 50
                    this.configLogo.y = 100
                    this.configLogo.width = 100
                    this.configLogo.height = 100
                    this.configLogo.MAX_WIDTH = 690
                    this.configLogo.MAX_HEIGH = 100
                    this.configLogo.minX = this.configLogo.x
                    this.configLogo.maxX = this.configVImagen.width - 110
                    this.configLogo.minY = this.configLogo.y
                    this.configLogo.maxY = this.configLogo.y + this.configVImagen.height

                    this.configTexto.x = 50
                    this.configTexto.y = 50
                }
                if (this.tipo == 'pulseras') {
                    switch (this.selectPulsera) {
                        case 'tyvek':
                            this.configKonva.width = 700
                            this.configKonva.height = 300

                            this.configVImagen.width = 690
                            this.configVImagen.height = 70
                            this.configVImagen.x = 5
                            this.configVImagen.y = 100

                            this.configVLayer.x = 10
                            this.configVLayer.y = 0
                            //this.configVLayer.width = 690;
                            layer.width(690)
                            //this.configVLayer.height = 50;
                            layer.height(50)
                            this.configVLayer.offsetX = 0
                            this.configVLayer.offsetY = 0

                            this.configLogo.x = 90
                            this.configLogo.y = 100
                            this.configLogo.width = 100
                            this.configLogo.height = 100
                            this.configLogo.MAX_WIDTH = 690
                            this.configLogo.MAX_HEIGH = 100
                            this.configLogo.minX = this.configLogo.x
                            this.configLogo.maxX = this.configVImagen.width - 110
                            this.configLogo.minY = this.configLogo.y
                            this.configLogo.maxY = this.configLogo.y + this.configVImagen.height

                            this.configTexto.x = 90
                            this.configTexto.y = 100

                            break
                        case 'glitter':
                            this.configKonva.width = 700
                            this.configKonva.height = 300

                            this.configVImagen.width = 690
                            this.configVImagen.height = 100
                            this.configVImagen.x = 5
                            this.configVImagen.y = 100

                            this.configVLayer.x = 10
                            this.configVLayer.y = 0
                            //this.configVLayer.width = 690;
                            layer.width(690)
                            layer.height(50)
                            // this.configVLayer.height = 50;
                            this.configVLayer.offsetX = 0
                            this.configVLayer.offsetY = 0

                            this.configLogo.x = 20
                            this.configLogo.y = 150
                            this.configLogo.width = 50
                            this.configLogo.height = 50
                            this.configLogo.MAX_WIDTH = 690
                            this.configLogo.MAX_HEIGH = 100
                            this.configLogo.minX = this.configLogo.x
                            this.configLogo.maxX = this.configVImagen.width - 320
                            this.configLogo.minY = this.configLogo.y
                            this.configLogo.maxY = this.configLogo.y

                            this.configTexto.x = 90
                            this.configTexto.y = 100

                            break
                        case 'vinilo':
                            this.configKonva.width = 700
                            this.configKonva.height = 300

                            this.configVImagen.width = 690
                            this.configVImagen.height = 100
                            this.configVImagen.x = 5
                            this.configVImagen.y = 100

                            this.configVLayer.x = 10
                            this.configVLayer.y = 0
                            //this.configVLayer.width = 690;
                            layer.width(690)
                            layer.height(50)
                            //this.configVLayer.height = 50;
                            this.configVLayer.offsetX = 0
                            this.configVLayer.offsetY = 0

                            this.configLogo.x = 20
                            this.configLogo.y = 150
                            this.configLogo.width = 50
                            this.configLogo.height = 50
                            this.configLogo.MAX_WIDTH = 690
                            this.configLogo.MAX_HEIGH = 100
                            this.configLogo.minX = this.configLogo.x
                            this.configLogo.maxX = this.configVImagen.width - 320
                            this.configLogo.minY = this.configLogo.y
                            this.configLogo.maxY = this.configLogo.y

                            this.configTexto.x = 90
                            this.configTexto.y = 100

                            break
                        case 'pvc':
                            this.configKonva.width = 700
                            this.configKonva.height = 300

                            this.configVImagen.width = 690
                            this.configVImagen.height = 100
                            this.configVImagen.x = 5
                            this.configVImagen.y = 100

                            this.configVLayer.x = 10
                            this.configVLayer.y = 0
                            //this.configVLayer.width = 690;
                            layer.width(690)
                            //this.configVLayer.height = 50;
                            layer.height(50)
                            this.configVLayer.offsetX = 0
                            this.configVLayer.offsetY = 0

                            this.configLogo.x = 20
                            this.configLogo.y = 150
                            this.configLogo.width = 50
                            this.configLogo.height = 50
                            this.configLogo.MAX_WIDTH = 690
                            this.configLogo.MAX_HEIGH = 100
                            this.configLogo.minX = this.configLogo.x
                            this.configLogo.maxX = this.configVImagen.width - 320
                            this.configLogo.minY = this.configLogo.y
                            this.configLogo.maxY = this.configLogo.y

                            this.configTexto.x = 90
                            this.configTexto.y = 100

                            break

                        default:
                    }
                }
            },
            setImagenDefault(color) {
                this.setcolores = color['colores']
                this.color = color['name']
                this.precios = color['precios']
                this.setMedidas()

                const image = new window.Image()
                image.src =
                    process.env.VUE_APP_BASE_URI + '/' + this.tipo + '/' + color['name']

                image.onload = () => {
                    // set image only when it is loaded
                    this.configVImagen.image = image
                }
            },
            CambiaFondo: function (color) {
                this.setcolores = color['colores']
                this.color = color['name']
                this.precios = color['precios']
                this.setMedidas()
                const image = new window.Image()
                image.src =
                    process.env.VUE_APP_BASE_URI + '/' + this.tipo + '/' + this.color
                image.onload = () => {
                    // set image only when it is loaded
                    this.configVImagen.image = image
                }
            },
            AddLogo: function (img) {
                this.setMedidas()
                this.i = this.i + 1

                var layer = this.$refs.layerEntrada.getStage()

                const name = 'imageObj' + this.i
                var imageObj = new Image()
                imageObj.src = img
                imageObj.name = 'imageObj' + this.i

                var x = this.configLogo.x
                var y = this.configLogo.y

                var MAX_WIDTH = this.configLogo.MAX_WIDTH
                var MAX_HEIGH = this.configLogo.MAX_HEIGH

                var v_image = new Object()
                v_image.x = x + this.i
                v_image.y = y + this.i
                v_image.image = imageObj
                v_image.width = imageObj.width / 2 //106;
                v_image.height = imageObj.height / 2 //118;
                v_image.draggable = true
                v_image.name = 'imageObj' + this.i
                v_image.MAX_WIDTH = MAX_WIDTH //700;
                v_image.MAX_HEIGH = MAX_HEIGH // 200;
                this.elementos.push(v_image)

                imageObj.onload = function () {
                    var img = new Konva.Image({
                        x: x,
                        y: y,
                        image: imageObj,
                        width: imageObj.width / 2, //106,
                        height: imageObj.height / 2, // 118,
                        draggable: true,
                        name: name,
                    })

                    // add the shape to the layer
                    layer.add(img)

                    layer.batchDraw()
                }
            },
            AddTexto: function (obj) {
                this.setMedidas()
                let layer = this.$refs.layerEntrada.getStage()

                this.i = this.i + 1

                const name = 'TextoObj' + this.i

                let x = this.configTexto.x
                let y = this.configTexto.y

                var v_texto = new Object()
                v_texto.text = obj.text
                v_texto.x = x
                v_texto.y = y
                v_texto.fontSize = obj.fontSize
                v_texto.fontFamily = obj.fontFamily
                v_texto.fill = obj.color
                v_texto.draggable = true
                v_texto.name = name
                this.elementos.push(v_texto)

                var textNode = new Konva.Text({
                    text: obj.text,
                    x: x,
                    y: y,
                    fontSize: obj.fontSize,
                    fontFamily: obj.fontFamily,
                    fill: obj.color,
                    align: 'center',
                    wrap: 'word',
                    draggable: true,
                    name: name,
                })

                layer.add(textNode)
                textNode.on('transform', function () {
                    // reset scale, so only with is changing by transformer
                    textNode.setAttrs({
                        width: textNode.width() * textNode.scaleX(),
                        height: textNode.height() * textNode.scaleY(),
                        fontSize: textNode.fontSize() * textNode.scaleY(),
                        scaleX: 1,
                        scaleY: 1,
                    })
                    layer.batchDraw()
                })

                layer.draw()
                layer.batchDraw()
            },
            AddTextoEdit: function (obj) {
                var layer = this.$refs.layerEntrada.getStage()

                this.i = this.i + 1
                const name = 'TextoObj' + this.i
                var v_texto = new Object()
                v_texto.text = obj.text
                v_texto.x = obj.x
                v_texto.y = obj.y
                v_texto.fontSize = obj.fontSize
                v_texto.fontFamily = obj.fontFamily
                v_texto.fill = obj.color
                v_texto.draggable = true
                v_texto.name = name
                this.elementos.push(v_texto)

                var textNode = new Konva.Text({
                    text: obj.text,
                    x: obj.x,
                    y: obj.y,
                    fontSize: obj.fontSize,
                    fontFamily: obj.fontFamily,
                    fill: obj.color,
                    align: 'center',
                    wrap: 'word',
                    draggable: true,
                    name: name,
                })

                layer.add(textNode)
                textNode.on('transform', function () {
                    // reset scale, so only with is changing by transformer
                    textNode.setAttrs({
                        width: textNode.width() * textNode.scaleX(),
                        height: textNode.height() * textNode.scaleY(),
                        fontSize: textNode.fontSize() * textNode.scaleY(),
                        scaleX: 1,
                        scaleY: 1,
                    })
                    layer.batchDraw()
                })
                layer.draw()
            },
            EditTexto(obj) {
                const transformerNode = this.$refs.transformer.getNode()
                const stage = transformerNode.getStage()
                const { selectedShapeName } = this
                const selectedNode = stage.findOne('.' + selectedShapeName)

                let newObj = {
                    text: obj.text,
                    x: selectedNode.attrs.x,
                    y: selectedNode.attrs.y,
                    fontSize: obj.fontSize,
                    fontFamily: obj.fontFamily,
                    color: obj.color,
                }
                this.eliminarElemento()
                this.AddTextoEdit(newObj)
            },

            handleStageMouseDown(e) {
                // clicked on stage - clear selection
                if (e.target === e.target.getStage()) {
                    this.selectedShapeName = ''
                    this.updateTransformer()
                    return
                }

                // clicked on transformer - do nothing
                const clickedOnTransformer =
                    e.target.getParent().className === 'Transformer'

                if (clickedOnTransformer) {
                    return
                }
                // find clicked rect by its name
                const name = e.target.name()

                const rect = this.elementos.find((r) => r.name === name)
                if (rect) {
                    this.selectedShapeName = name
                } else {
                    this.selectedShapeName = ''
                }
                this.updateTransformer()
            },
            updateTransformer() {
                // here we need to manually attach or detach Transformer node
                const transformerNode = this.$refs.transformer.getNode()
                const stage = transformerNode.getStage()
                const { selectedShapeName } = this
                const selectedNode = stage.findOne('.' + selectedShapeName)
                var layer = this.$refs.layerEntrada.getStage()

                // do nothing if selected node is already attached
                if (selectedNode == transformerNode.node()) {
                    return
                }
                if (selectedNode) {
                    // attach to another node
                    this.trActivo = true
                    this.$bvToast.show('edit-delete')
                    this.text = true
                    if (selectedNode.image) {
                        this.text = false
                    }

                    transformerNode.attachTo(selectedNode)
                } else {
                    this.trActivo = false
                    this.$bvToast.hide('edit-delete')
                    // remove transformer
                    this.text = false
                    transformerNode.detach()
                }

                transformerNode.getLayer().batchDraw()
            },
            editarTransformar() {
                const crtTexto = this.$refs.Texto
                const transformerNode = this.$refs.transformer.getNode()
                const stage = transformerNode.getStage()
                const { selectedShapeName } = this
                const selectedNode = stage.findOne('.' + selectedShapeName)
                if (selectedNode) {
                    const atributos = selectedNode.attrs
                    if (atributos.text) {
                        crtTexto.texto = atributos.text
                        crtTexto.selectedFont = atributos.fontFamily
                        crtTexto.color = atributos.fill
                        crtTexto.selectedSize = atributos.fontSize
                        crtTexto.id = selectedNode._id
                        this.$bvModal.show('modal-editar-texto')
                    } else {
                        crtTexto.selectedSize = 10
                        crtTexto.selectedFont = crtTexto.selectedFontdefault
                        crtTexto.color = 'black'
                        crtTexto.texto = ''
                        crtTexto.valida = false
                        crtTexto.id = null
                    }
                }
            },
            eliminarElemento() {
                const transformerNode = this.$refs.transformer.getNode()
                const stage = transformerNode.getStage()
                const { selectedShapeName } = this
                const selectedNode = stage.findOne('.' + selectedShapeName)
                selectedNode.destroy()
                transformerNode.detach()
                transformerNode.getLayer().batchDraw()
                this.$bvToast.hide('edit-delete')
            },
        },
    }
</script>
<style>
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
    }
</style>